import React, { useEffect, useRef, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Session from './auth/Session';

function Guard({ component: Component, location, ...rest }) {
    const initialTokenRef = useRef(Session.getToken());
    const [valid, setValid] = useState(Session.isTokenValid());

    useEffect(() => {
        const check = () => {
            const currentToken = Session.getToken();
            // Invalid outright, OR another tab swapped in a different
            // (possibly still "valid") token for a different session.
            if (!Session.isTokenValid() || currentToken !== initialTokenRef.current) {
                setValid(false);
            }
        };
        const onStorage = (e) => {
            // e.key is null when a tab calls localStorage.clear()
            if (e.key === 'token' || e.key === null) check();
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    if (!valid) {
        return (
            <Redirect
                to={{
                    pathname: '/login',
                    state: {
                        from: location,
                        message: 'You were logged out in another tab. Please log in again.',
                    },
                }}
            />
        );
    }
    return <Component {...rest} location={location} />;
}

export function ProtectedRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => <Guard component={Component} {...props} />}
        />
    );
}